import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Observable } from 'rxjs';
import classnames from 'classnames';
import noop from 'lodash/noop';

import theme from './CircleTimer.scss';
import { injectIntl } from 'react-intl';

const propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.number,
  ticksAmount: PropTypes.number.isRequired,
  intervalBetweenTicks: PropTypes.number.isRequired,
  size: PropTypes.number,
  reverse: PropTypes.bool,
  restartTimer: PropTypes.bool, // todo: [Igor] probably remove

  timeValueFormatter: PropTypes.func,
  onChange: PropTypes.func,
  onComplete: PropTypes.func,
};

const defaultProps = {
  className: '',
  defaultValue: 0,
  size: 25,
  reverse: false,
  restartTimer: false,

  timeValueFormatter: (value) => value,
  onChange: noop,
  onComplete: noop,
};

class CircleTimer extends Component {

  state = {
    timeValue: 0,
    offset: 0,
    circumference: Math.PI * 2 * (this.props.size / 2),
  };

  componentDidMount() {
    this.startTimer();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.restartTimer !== this.props.restartTimer &&
        nextProps.restartTimer === true
    ) {
      this.restartTimer();
    }
  }

  componentWillUnmount() {
    this.timer$.unsubscribe();
  }

  startTimer = () => {
    const {
      defaultValue,
      ticksAmount,
      intervalBetweenTicks,
      reverse,
      onChange,
      onComplete,
    } = this.props;

    const currentTick = defaultValue || (reverse ? ticksAmount : 0);
    const { circumference } = this.state;
    const startTime = Date.now();

    const getTick = () => {
      const thisTick = Math.floor((Date.now() - startTime) / intervalBetweenTicks);
      return reverse ? currentTick - thisTick : currentTick + thisTick;
    };

    const setTimeValue = (value) => {
      this.setState({
        timeValue: value,
        offset: circumference + ((circumference * value) / ticksAmount),
      });
    };
    setTimeValue(getTick());

    this.timer$ = Observable
      .interval(intervalBetweenTicks)
      .takeUntil(Observable.timer(currentTick * intervalBetweenTicks))
      .map(getTick)
      .do(onChange)
      .finally(onComplete)
      .subscribe(setTimeValue);
  };

  restartTimer = () => {
    this.startTimer();
  };

  renderCircleAnimation() {
    const { size, intl } = this.props;
    const { timeValue, offset, circumference } = this.state;
    const ariaLabel = intl.formatMessage(
      { id: 'SendOTPAgainButton.TitleAttribute', defaultMessage: '** Send code again in { secondsConterValue } seconds' },
      { secondsConterValue: timeValue });

    return (
      <div className={ theme.circle }>
        <svg aria-label={ ariaLabel } width={ size } viewBox={ `0 0 ${ size } ${ size }` } xmlns="http://www.w3.org/2000/svg">
          <g transform={ `translate(${ size / 2 }, ${ size / 2 })` }>
            <circle r={ (size - 1) / 2 } className={ theme.base } />
            <g transform="rotate(-90)">
              <circle r={ (size - 1) / 2 } className={ theme.progress } strokeDasharray={ circumference } strokeDashoffset={ offset } />
            </g>
          </g>
        </svg>
      </div>
    );
  }

  render() {
    const { timeValueFormatter, className, size } = this.props;
    const { timeValue } = this.state;

    if (!timeValue) {
      return null;
    }



    return (
      <div
        className={ classnames(theme.root, className) }
        style={ {
          width: `${ size }px`,
          height: `${ size }px`,
        } }
      >
        { this.renderCircleAnimation() }

        <div className={ theme.time } >
          { timeValueFormatter(timeValue) }
        </div>
      </div>
    );
  }
}

CircleTimer.propTypes = propTypes;
CircleTimer.defaultProps = defaultProps;

export default injectIntl(CircleTimer);
